import PropTypes from 'prop-types';
import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  border-radius: 6px;
  box-shadow: var(--level-3);
  font-size: var(--x-small);
  background-color: #fff;
  pointer-events: auto;
`;

export const TooltipHeader = styled.div`
  background-color: var(--tooltip-header-bg);
  color: var(--tooltip-header-color);
  border-radius: 6px 6px 0 0;
  padding: 8px 24px;
`;

export const TooltipTitle = styled.h3`
  font-weight: var(--bold);
  font-size: ${({ size }) => {
    switch (size) {
      case 'xxs':
        return 'var(--xx-small)';
      case 'xs':
        return 'var(--x-small)';
      case 's':
        return 'var(--small)';
      case 'm':
        return 'var(--regular)';
      case 'ml':
        return 'var(--medium-large)';
      case 'l':
        return 'var(--large)';
      case 'xl':
        return 'var(--x-large)';
      case 'xxl':
        return 'var(--x-large)';
      default:
        return 'var(--regular)';
    }
  }};
`;

TooltipTitle.propTypes = {
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'ml', 'l', 'xl', 'xxl']),
};
